import * as actionTypes from './actionsTypes';

export const setcoursecart = (payload) => {
    return {
        type: actionTypes.SETCOURSECART,
        value: payload
    }
}